import { usePagination } from "react-instantsearch"

export default function Pagination() {
    
    const { pages, nbHits, nbPages, isFirstPage, isLastPage, canRefine, currentRefinement, refine, createURL } = usePagination();

    const firstPageIndex = 0;
    const lastPageIndex = nbPages - 1;

    return (
        <div className={"finish-pagination__wrapper"}>
            <a 
                key={"pagination-previous-page"}
                onClick={(event) => {
                    event.preventDefault();
                    refine(currentRefinement - 1)
                }} 
                className={"finish-pagination__button"}
                style={currentRefinement === firstPageIndex ? { display: "none" } : { display: "block" }}
            >
                <span className={`finish-pagination__item`}>&lt;</span>
            </a>
            <a 
                key={"pagination-first-element"}
                onClick={(event) => {
                    event.preventDefault();
                    refine(firstPageIndex)
                }} 
                className={"finish-pagination__button"}
                style={currentRefinement >= 4 && nbPages > 7 ? { display: "block" } : { display: "none" }}
            >
                <span className={`finish-pagination__item`}>{firstPageIndex+1}</span>
            </a>

            <span style={currentRefinement >= 4 && nbPages > 7 ? { display: "block" } : { display: "none" }}>...</span>

            {
                canRefine && pages.map((page, idx) => {
                    return (
                        <a 
                            key={page}
                            onClick={(event) => {
                                event.preventDefault();
                                refine(page)
                            }} 
                            className={"finish-pagination__button"}
                        >
                            <span 
                                className={`finish-pagination__item ${currentRefinement === idx ? "finish-pagination__item--active" : ""}`}
                            >
                                { page + 1 }
                            </span>
                        </a>
                    )
                })
            }
            <span style={currentRefinement < nbPages - 4 && nbPages > 7 ? { display: "block" } : { display: "none" }}>...</span>
            <a 
                key={"pagination-last-elem"}
                onClick={(event) => {
                    event.preventDefault();
                    refine(lastPageIndex)
                }} 
                className={"finish-pagination__button"}
                style={currentRefinement < nbPages - 4 && nbPages > 7 ? { display: "block" } : { display: "none" }}
            >
                <span className={`finish-pagination__item`}>{lastPageIndex+1}</span>
            </a>
            <a 
                key={"pagination-next-page"}
                onClick={(event) => {
                    event.preventDefault();
                    refine(currentRefinement + 1)
                }} 
                className={"finish-pagination__button"}
                style={currentRefinement === lastPageIndex ? { display: "none" } : { display: "block" }}
            >
                <span className={`finish-pagination__item`}>&gt;</span>
            </a>
        </div>
        
    )
}